"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const react_1 = tslib_1.__importDefault(require("react"));
const constants_1 = require("../../constants");
const useScreenSize_1 = require("../../useScreenSize");
const Container = (_a) => {
    var { style } = _a, rest = tslib_1.__rest(_a, ["style"]);
    const screenSize = useScreenSize_1.useScreenSize();
    return (react_1.default.createElement(components_1.View, Object.assign({}, rest, { style: [
            {
                width: constants_1.MAX_CONTAINER_WIDTH[screenSize],
                alignSelf: 'center',
                flexGrow: 1
            },
            style
        ] })));
};
exports.Container = Container;
exports.Container.displayName = 'Container';
